<nav class="navbar navbar-expand navbar-dark bg-transparent batt-category-nav" *ngIf="
    !_sport.excludeSports.includes(_router.url.split('/')?.pop()) &&
    (_common.showsports | async)
  ">
  <div class="container">
    <div class="batt-category-box mx-auto overflow-auto d-block">
      <ul class="navbar-nav">
        <ng-container *ngIf="_common.configuration | async as configuration">
          <ng-container *ngFor="let sport of configuration.sports">
            <li class="nav-item" *ngIf="sport.name?.toLowerCase() !== 'general'">
              <a *ngIf="_router.url.search('profile') == -1; else showhref" class="nav-link"
                [class.active]="selectedSport == sport.value?.toLowerCase()" [class.d-none]="
                  sport.name?.toLowerCase() == 'all' &&
                  !_sport.includeAllPages.includes(_router.url.split('?')?.[0]?.split('/').pop())
                " [routerLink]="_router.url | sportUrl: sport.value">{{ sport.name }}</a>
              <ng-template #showhref>
                <a class="nav-link" [class.active]="selectedSport == sport.value?.toLowerCase()" [class.d-none]="
                    sport.name?.toLowerCase() == 'all' &&
                    !_sport.includeAllPages.includes(
                      _router.url.split('/').pop()
                    )
                  " [href]="(_router.url | sportUrl: sport.value)?.join('/')">{{ sport.name }}</a>
              </ng-template>
            </li>
          </ng-container>
        </ng-container>
      </ul>
    </div>
  </div>
</nav>